import { FC } from 'react'

import { Pages } from './Pages'
import { PaginationNumber } from './components'

import { s } from './styles'

type Props = {
  onPageChange: (page: number) => void
  pageCount: number
  selectedPage: number
}

export const CompactPages: FC<Props> = ({ pageCount, selectedPage, onPageChange }) => {
  if (selectedPage > pageCount - 4) {
    return (
      <>
        <PaginationNumber onClick={() => onPageChange(1)} value={1} />
        <s.Space />
        <Pages pageCount={5} selectedPage={selectedPage} onPageChange={onPageChange} enlargement={pageCount - 4} />
      </>
    )
  }
  if (selectedPage < 5) {
    return (
      <>
        <Pages pageCount={5} selectedPage={selectedPage} onPageChange={onPageChange} />
        <s.Space />
        <PaginationNumber onClick={() => onPageChange(pageCount)} value={pageCount} />
      </>
    )
  }

  return (
    <>
      <PaginationNumber onClick={() => onPageChange(1)} value={1} />
      <s.Space />
      <Pages pageCount={3} selectedPage={selectedPage} onPageChange={onPageChange} enlargement={selectedPage - 1} />
      <s.Space />
      <PaginationNumber onClick={() => onPageChange(pageCount)} value={pageCount} />
    </>
  )
}
